import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();


// WEBPACK FOOTER //
// ./src/utils/history.js